/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { Amount } from '../models/amount';
import { appV2ShipmentAccountedAmounts } from '../fn/shipment/app-v-2-shipment-accounted-amounts';
import { AppV2ShipmentAccountedAmounts$Params } from '../fn/shipment/app-v-2-shipment-accounted-amounts';
import { appV2ShipmentDelete } from '../fn/shipment/app-v-2-shipment-delete';
import { AppV2ShipmentDelete$Params } from '../fn/shipment/app-v-2-shipment-delete';
import { appV2ShipmentGet } from '../fn/shipment/app-v-2-shipment-get';
import { AppV2ShipmentGet$Params } from '../fn/shipment/app-v-2-shipment-get';
import { appV2ShipmentGetInternalInfo } from '../fn/shipment/app-v-2-shipment-get-internal-info';
import { AppV2ShipmentGetInternalInfo$Params } from '../fn/shipment/app-v-2-shipment-get-internal-info';
import { appV2ShipmentHistory } from '../fn/shipment/app-v-2-shipment-history';
import { AppV2ShipmentHistory$Params } from '../fn/shipment/app-v-2-shipment-history';
import { appV2ShipmentInvoices } from '../fn/shipment/app-v-2-shipment-invoices';
import { AppV2ShipmentInvoices$Params } from '../fn/shipment/app-v-2-shipment-invoices';
import { appV2ShipmentLabels } from '../fn/shipment/app-v-2-shipment-labels';
import { AppV2ShipmentLabels$Params } from '../fn/shipment/app-v-2-shipment-labels';
import { appV2ShipmentReTryRegister } from '../fn/shipment/app-v-2-shipment-re-try-register';
import { AppV2ShipmentReTryRegister$Params } from '../fn/shipment/app-v-2-shipment-re-try-register';
import { appV2ShipmentStore } from '../fn/shipment/app-v-2-shipment-store';
import { AppV2ShipmentStore$Params } from '../fn/shipment/app-v-2-shipment-store';
import { appV2ShipmentUpdate } from '../fn/shipment/app-v-2-shipment-update';
import { AppV2ShipmentUpdate$Params } from '../fn/shipment/app-v-2-shipment-update';
import { ParcelHistory } from '../models/parcel-history';
import { Shipment } from '../models/shipment';
import { ShipmentHistoryRow } from '../models/shipment-history-row';
import { ShipmentInternalInfo } from '../models/shipment-internal-info';
import { ShipmentInvoice } from '../models/shipment-invoice';


/**
 * Shipment
 */
@Injectable({ providedIn: 'root' })
export class ShipmentService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `appV2ShipmentGet()` */
  static readonly AppV2ShipmentGetPath = '/app/v2/shipment/{internalNumber}';

  /**
   * Get a shipment info.
   *
   * Get information about shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentGet$Response(params: AppV2ShipmentGet$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'context'?: string;
'shipment'?: Shipment;
}>> {
    return appV2ShipmentGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a shipment info.
   *
   * Get information about shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentGet(params: AppV2ShipmentGet$Params, context?: HttpContext): Observable<{
'context'?: string;
'shipment'?: Shipment;
}> {
    return this.appV2ShipmentGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'context'?: string;
'shipment'?: Shipment;
}>): {
'context'?: string;
'shipment'?: Shipment;
} => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentGetInternalInfo()` */
  static readonly AppV2ShipmentGetInternalInfoPath = '/app/v2/shipment/{internalNumber}/internal_info';

  /**
   * Get a internal shipment info.
   *
   * Get internal information about shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentGetInternalInfo()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentGetInternalInfo$Response(params: AppV2ShipmentGetInternalInfo$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'context'?: string;
'data'?: ShipmentInternalInfo;
}>> {
    return appV2ShipmentGetInternalInfo(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a internal shipment info.
   *
   * Get internal information about shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentGetInternalInfo$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentGetInternalInfo(params: AppV2ShipmentGetInternalInfo$Params, context?: HttpContext): Observable<{
'context'?: string;
'data'?: ShipmentInternalInfo;
}> {
    return this.appV2ShipmentGetInternalInfo$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'context'?: string;
'data'?: ShipmentInternalInfo;
}>): {
'context'?: string;
'data'?: ShipmentInternalInfo;
} => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentUpdate()` */
  static readonly AppV2ShipmentUpdatePath = '/app/v2/shipment/';

  /**
   * Update shipment.
   *
   * update shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentUpdate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentUpdate$Response(params?: AppV2ShipmentUpdate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appV2ShipmentUpdate(this.http, this.rootUrl, params, context);
  }

  /**
   * Update shipment.
   *
   * update shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentUpdate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentUpdate(params?: AppV2ShipmentUpdate$Params, context?: HttpContext): Observable<void> {
    return this.appV2ShipmentUpdate$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentStore()` */
  static readonly AppV2ShipmentStorePath = '/app/v2/shipment/';

  /**
   * Store shipment.
   *
   * store shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentStore()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentStore$Response(params?: AppV2ShipmentStore$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'internal_waybill'?: string;
}>> {
    return appV2ShipmentStore(this.http, this.rootUrl, params, context);
  }

  /**
   * Store shipment.
   *
   * store shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentStore$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentStore(params?: AppV2ShipmentStore$Params, context?: HttpContext): Observable<{
'internal_waybill'?: string;
}> {
    return this.appV2ShipmentStore$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'internal_waybill'?: string;
}>): {
'internal_waybill'?: string;
} => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentDelete()` */
  static readonly AppV2ShipmentDeletePath = '/app/v2/shipment/';

  /**
   * Delete shipment.
   *
   * delete shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentDelete()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentDelete$Response(params?: AppV2ShipmentDelete$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appV2ShipmentDelete(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete shipment.
   *
   * delete shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentDelete$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentDelete(params?: AppV2ShipmentDelete$Params, context?: HttpContext): Observable<void> {
    return this.appV2ShipmentDelete$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentReTryRegister()` */
  static readonly AppV2ShipmentReTryRegisterPath = '/app/v2/shipment/';

  /**
   * Re try register shipment.
   *
   * re try register shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentReTryRegister()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentReTryRegister$Response(params?: AppV2ShipmentReTryRegister$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appV2ShipmentReTryRegister(this.http, this.rootUrl, params, context);
  }

  /**
   * Re try register shipment.
   *
   * re try register shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentReTryRegister$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  appV2ShipmentReTryRegister(params?: AppV2ShipmentReTryRegister$Params, context?: HttpContext): Observable<void> {
    return this.appV2ShipmentReTryRegister$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentHistory()` */
  static readonly AppV2ShipmentHistoryPath = '/app/v2/shipment/{internalNumber}/history';

  /**
   * Get a shipment info.
   *
   * Get history information about shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentHistory()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentHistory$Response(params: AppV2ShipmentHistory$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'history'?: {
'shipment'?: Array<ShipmentHistoryRow>;
'parcels'?: Array<ParcelHistory>;
};
}>> {
    return appV2ShipmentHistory(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a shipment info.
   *
   * Get history information about shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentHistory$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentHistory(params: AppV2ShipmentHistory$Params, context?: HttpContext): Observable<{
'history'?: {
'shipment'?: Array<ShipmentHistoryRow>;
'parcels'?: Array<ParcelHistory>;
};
}> {
    return this.appV2ShipmentHistory$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'history'?: {
'shipment'?: Array<ShipmentHistoryRow>;
'parcels'?: Array<ParcelHistory>;
};
}>): {
'history'?: {
'shipment'?: Array<ShipmentHistoryRow>;
'parcels'?: Array<ParcelHistory>;
};
} => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentLabels()` */
  static readonly AppV2ShipmentLabelsPath = '/app/v2/shipment/{internalNumber}/labels/{size}';

  /**
   * Get a accounting amounts shipment info.
   *
   * Get accounting amounts information about shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentLabels()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentLabels$Response(params: AppV2ShipmentLabels$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return appV2ShipmentLabels(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a accounting amounts shipment info.
   *
   * Get accounting amounts information about shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentLabels$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentLabels(params: AppV2ShipmentLabels$Params, context?: HttpContext): Observable<void> {
    return this.appV2ShipmentLabels$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentAccountedAmounts()` */
  static readonly AppV2ShipmentAccountedAmountsPath = '/app/v2/shipment/{internalNumber}/accounted-amounts';

  /**
   * Get a accounting amounts shipment info.
   *
   * Get accounting amounts information about shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentAccountedAmounts()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentAccountedAmounts$Response(params: AppV2ShipmentAccountedAmounts$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'accounted_amounts'?: {
'main'?: Amount;
'after_service'?: Amount | null;
};
}>> {
    return appV2ShipmentAccountedAmounts(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a accounting amounts shipment info.
   *
   * Get accounting amounts information about shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentAccountedAmounts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentAccountedAmounts(params: AppV2ShipmentAccountedAmounts$Params, context?: HttpContext): Observable<{
'accounted_amounts'?: {
'main'?: Amount;
'after_service'?: Amount | null;
};
}> {
    return this.appV2ShipmentAccountedAmounts$Response(params, context).pipe(
      map((r: StrictHttpResponse<{
'accounted_amounts'?: {
'main'?: Amount;
'after_service'?: Amount | null;
};
}>): {
'accounted_amounts'?: {
'main'?: Amount;
'after_service'?: Amount | null;
};
} => r.body)
    );
  }

  /** Path part for operation `appV2ShipmentInvoices()` */
  static readonly AppV2ShipmentInvoicesPath = '/app/v2/shipment/{internalNumber}/invoices';

  /**
   * Get a invoices shipment info.
   *
   * Get invoices information about shipment
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `appV2ShipmentInvoices()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentInvoices$Response(params: AppV2ShipmentInvoices$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ShipmentInvoice>>> {
    return appV2ShipmentInvoices(this.http, this.rootUrl, params, context);
  }

  /**
   * Get a invoices shipment info.
   *
   * Get invoices information about shipment
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `appV2ShipmentInvoices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  appV2ShipmentInvoices(params: AppV2ShipmentInvoices$Params, context?: HttpContext): Observable<Array<ShipmentInvoice>> {
    return this.appV2ShipmentInvoices$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<ShipmentInvoice>>): Array<ShipmentInvoice> => r.body)
    );
  }

}
